export enum AiStates {
  off,
  on,
  paused,
}
